import { CardItem } from './card-item.model';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';

export class QuestItem implements Deserializable<JsonObject, QuestItem> {
  constructor(public id?: string, public card?: CardItem, public isMilestone?: boolean, public order?: string) {}

  deserialize(input: JsonObject): QuestItem {
    if (input == null) {
      return null;
    }

    const cardTab = input.tabs?.find((tab) => (tab.key = 'guide'));
    this.id = input.id;
    const card: JsonObject = cardTab?.data?.card || {};
    card['inQuest'] = true;
    this.card = new CardItem().deserialize(card);
    this.isMilestone = input.isMilestone;
    this.order = input.order;
    return this;
  }
}
